import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useT } from '../i18n/i18n';
import { CATEGORIES, STATUS_LABEL, fetchGuides, type GuideList } from './guides';

export default function LearnPage() {
  const t = useT();
  const [data, setData] = useState<GuideList | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetchGuides().then(setData).catch((e) => setError(e instanceof Error ? e.message : t('The guides could not be loaded.')));
  }, []);

  return (
    <div className="learn">
      <div className="card">
        <h1 style={{ marginTop: 0 }}>{t('Learn about autism')}</h1>
        <p>{t('Plain guides on understanding autism, teaching new skills and the support you can get. Each one is checked by a qualified professional before it appears here, and lists its sources.')}</p>
        <p className="field-hint" style={{ marginBottom: 0 }}>{t('These guides are general information, not medical advice. Speak to a GP or another professional about your own child.')}</p>
        {data?.reviewer && (
          <p className="field-hint" style={{ marginBottom: 0 }}>
            {data.canReview
              ? t('You are a reviewer: you can see every guide, including ones waiting for review.')
              : t('You can see every guide, including drafts. Only an approved consultant can approve one.')}
          </p>
        )}
      </div>

      {error && <div className="error" role="alert">{error}</div>}
      {!data && !error && <p className="muted" role="status">{t('Loading…')}</p>}

      {data && data.guides.length === 0 && (
        <div className="card">
          <p style={{ margin: 0 }}>{t('The guides are being checked by a qualified reviewer. They will appear here once they have been approved.')}</p>
        </div>
      )}

      {data && CATEGORIES.map((c) => {
        const list = data.guides.filter((g) => g.category === c.id);
        if (list.length === 0) return null;
        return (
          <section key={c.id} className="card learn-section" aria-labelledby={`cat-${c.id}`}>
            <h2 id={`cat-${c.id}`}>{t(c.title)}</h2>
            <ul className="learn-list">
              {list.map((g) => (
                <li key={g.slug}>
                  <Link to={`/assist/learn/${g.slug}`} className="learn-item">
                    <span className="learn-title">{g.title}</span>
                    <span className="learn-summary">{g.summary}</span>
                    {data.reviewer && <span className={`pill learn-status is-${g.status.toLowerCase()}`}>{t(STATUS_LABEL[g.status])}</span>}
                  </Link>
                </li>
              ))}
            </ul>
          </section>
        );
      })}

      <p><Link to="/assist">{t('Back to Assist')}</Link></p>
    </div>
  );
}
